// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-dropdown__container{border:1px solid #707070;border-radius:10px}.filter-dropdown__overlay--background{position:fixed;top:0;left:0;right:0;bottom:0;background-color:#000;opacity:.5;z-index:9}.filter-dropdown__overlay--container{position:fixed;left:0;top:0;right:0;bottom:0;background-color:#fff;z-index:10;padding:20px 16px}.filter-dropdown__item-disabled{opacity:.5}", ""]);
// Exports
module.exports = exports;
